function HideIf(props: any) {
  const { show } = props;
  if (show) {
    return props.children;
  }
  return null;
}

export default HideIf;
